/**
 * WordPress dependencies
 */
const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

/**
 * Internal dependencies
 */
import Edit from './edit'
import icon from './icon'

registerBlockType( 'gravityforms/form', {

	title:       __( 'Gravity Forms', 'gravityforms' ),
	description: __( 'Select and display one of your forms.', 'gravityforms' ),
	category:    'embed',
	supports:    {
		customClassName: false,
		className:       false,
		html:            false,
	},
	keywords:    [ 'gravity forms', 'newsletter', 'contact' ],
	example: {
		attributes: {
			imgPreview: true,
		},
	},
	attributes:  {
		formId:      {
			type: 'string',
		},
		title:       {
			type:    'boolean',
			default: true,
		},
		description: {
			type:    'boolean',
			default: true,
		},
		ajax:        {
			type:    'boolean',
			default: false,
		},
		tabindex:    {
			type: 'string',
		},
		fieldValues: {
			type: 'string',
		},
		formPreview: {
			type:    'boolean',
			default: true,
		},
		imgPreview: {
			type:    'boolean',
			default: false,
		},
	},
	icon:        icon,

	transforms: {
		from: [
			{
				type:       'shortcode',
				tag:        [ 'gravityform', 'gravityforms' ],
				attributes: {
					formId:      {
						type:      'string',
						shortcode: ( { named: { id } } ) => {
							return parseInt( id ).toString();
						},
					},
					title:       {
						type:      'boolean',
						shortcode: ( { named: { title } } ) => {
							return 'true' === title;
						},
					},
					description: {
						type:      'boolean',
						shortcode: ( { named: { description } } ) => {
							return 'true' === description;
						},
					},
					ajax:        {
						type:      'boolean',
						shortcode: ( { named: { ajax } } ) => {
							return 'true' === ajax;
						},
					},
					tabindex:    {
						type:      'string',
						shortcode: ( { named: { tabindex } } ) => {
							return isNaN( tabindex ) ? null : parseInt( tabindex ).toString();
						},
					}
				},
			}
		]
	},

	edit: Edit,

	save() {
		return (
			null
		);
	},

} );
